// Issued identity outlives a draft, restaurant visit, TTL and purchase revision.
// This is a read-only receipt, not payment credentials or permission to replay.
const scope = (account, restaurant) =>
  account != null && restaurant != null
    ? JSON.stringify([String(account), String(restaurant)])
    : null;

export function retainIssuedCheckout(records, checkout) {
  const retained = records || {};
  const key = scope(checkout?.accountId, checkout?.restaurant);
  if (!key) return retained;
  if (checkout.isEnded) {
    if (retained[key]?.id !== checkout.id) return retained;
    const next = { ...retained };
    delete next[key];
    return next;
  }
  if (!checkout.paymentIssued) return retained;
  const fields = [
    'id',
    'accountId',
    'restaurant',
    'ordinaryCheckout',
    'paymentIssued',
    'delivery_revision',
    'total',
    'subtotal',
    'taxes',
    'fees',
    'coupons',
    'gift_certificate',
    'gift_certificates',
    'schedule',
    'payments',
    'items',
    'created_at',
    'ttl_seconds',
    'issuanceRequest',
    'stripeAccountId',
    'paymentIntentId',
    'issuedAmount',
    'saved_cart',
    'saved_destination',
  ];
  return {
    ...retained,
    [key]: Object.fromEntries(
      fields
        .filter((field) =>
          Object.prototype.hasOwnProperty.call(checkout, field)
        )
        .map((field) => [
          field,
          field === 'payments' && Array.isArray(checkout.payments)
            ? checkout.payments.map(({ type }) => ({ type }))
            : checkout[field],
        ])
    ),
  };
}

// A start conflict supplies an authority, not a new quote or replacement grant.
export const conflictedCheckout = (id, state, resolution = {}) => ({
  ...resolution.totals,
  id,
  accountId: state.main.user?.id,
  restaurant: state.restaurant.selectedRestaurantId,
  ordinaryCheckout: true,
  paymentIssued: true,
  delivery_revision: resolution.delivery_revision,
  saved_cart: resolution.saved_cart,
  saved_destination: resolution.saved_destination,
});

export function readIssuedCheckout(state) {
  const key = scope(
    state.main?.user?.id,
    state.restaurant?.selectedRestaurantId
  );
  const checkout = key && state.order?.issuedCheckouts?.[key];
  return checkout?.paymentIssued &&
    !checkout.isEnded &&
    scope(checkout.accountId, checkout.restaurant) === key
    ? checkout
    : null;
}
